import { useQuery } from "@apollo/client";
import { AutocompleteElement } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { SettingsObservationTypeEditRoute_FunctionTypeGetAllAssignableDocument } from "../../queries.generated";

type Props = {
    researchTypeId: string;
    observationTypeId: string;
};

export default function ObservationTypeFunctionTypeSelectElement({ researchTypeId, observationTypeId }: Props) {
    const { t } = useTranslation("observationType");

    const { data, loading } = useQuery(SettingsObservationTypeEditRoute_FunctionTypeGetAllAssignableDocument, {
        variables: { researchTypeId, observationTypeId },
    });

    const options =
        data?.settingsEcologicalFunctionTypeGetAllAssignable.map(ft => ({ label: ft.name, id: ft.id })) ?? [];

    return (
        <AutocompleteElement
            name="ecologicalFunctionTypeId"
            label={t("observationTypeFunctionTypeSelectElement.labelAddFunctionType")}
            loading={loading}
            options={options}
            matchId
        />
    );
}
